import React, { useState, useEffect } from 'react';
import { ShoppingCart, Menu, X, Phone, Mail } from 'lucide-react';
import { navCategories } from '../mock';
import SearchBar from './SearchBar';

const Header = ({ cartCount = 0, onCartClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setIsScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full bg-white shadow-sm">
      {/* Top utility bar */}
      <div className="hidden md:block bg-[#1a1a1a] text-white text-xs">
        <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-5">
            <span className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5" /> 0747 825 465</span>
            <span className="flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" /> eddma.metal.art@gmail.com</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="#portofoliu" className="hover:text-amber-400 transition-colors">Portofoliu</a>
            <a href="#contact" className="hover:text-amber-400 transition-colors">Contact</a>
            <a href="#blog" className="hover:text-amber-400 transition-colors">Blog</a>
          </div>
        </div>
      </div>

      {/* Main bar */}
      <div className={`transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`}>
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between gap-6">
          {/* Logo */}
          <a href="/" className="flex flex-col items-start leading-none flex-shrink-0">
            <span className="font-extrabold tracking-tight text-[#1a1a1a]" style={{ fontFamily: 'Playfair Display, Georgia, serif', fontSize: isScrolled ? '32px' : '40px', letterSpacing: '-0.02em' }}>
              EddMa
            </span>
            <span className="text-[10px] uppercase tracking-[0.35em] text-gray-500 font-medium -mt-0.5">
              metal art
            </span>
          </a>

          {/* Search */}
          <div className="hidden lg:flex flex-1 max-w-2xl">
            <SearchBar />
          </div>

          {/* Icons */}
          <div className="flex items-center gap-1">
            <button
              onClick={onCartClick}
              className="flex flex-col items-center gap-0.5 px-3 py-1.5 hover:text-amber-600 transition-colors relative"
            >
              <div className="relative">
                <ShoppingCart className="w-5 h-5" />
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-amber-500 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-bold">{cartCount}</span>
                )}
              </div>
              <span className="text-[10px] uppercase tracking-wide hidden md:block">Coș</span>
            </button>
            <button className="lg:hidden p-2" onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Categories navigation */}
      <nav className="hidden lg:block bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <ul className="flex items-center gap-1">
            {navCategories.map((c) => (
              <li key={c.name}>
                <a
                  href={c.href}
                  className="block px-4 py-3 text-[13px] font-medium text-gray-700 hover:text-amber-600 relative group transition-colors"
                >
                  {c.name}
                  <span className="absolute left-4 right-4 bottom-2 h-0.5 bg-amber-500 scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden border-t border-gray-100 bg-white">
          <div className="px-4 py-3">
            <div className="mb-3">
              <SearchBar />
            </div>
            <ul className="divide-y divide-gray-100">
              {navCategories.map((c) => (
                <li key={c.name}>
                  <a href={c.href} className="block py-3 text-sm text-gray-700 hover:text-amber-600" onClick={() => setMobileOpen(false)}>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
